export const roundNumber = (number) => Math.round(+number)
export const floorNumber = (number) => Math.floor(+number)
